export enum AptContactRole {
    RappresentanteLegale = 'LEGALE RAPPRESENTANTE',
    Referente = 'REFERENTE', //trasformato da delegato -> referente per bug #147245
    Cliente = 'CLIENTE',
}
